module.exports = __webpack_public_path__ + "static/media/instagram.ceaae5e2.svg";